import type { IEMBuyProgramCatalogItem } from '@/services/iem';

export type IssuePlannerView = 'missing' | 'all';

export type IssuePlannerItem = {
  id: string;
  item: string;
  lin: string;
  nsn: string;
  need: number;
  authorizedQty: number;
  currentQty: number;
  cartName?: string;
  catalogId?: string | null;
  kitName?: string | null;
  ieKitId?: string | null;
  quantityToIssue?: number;
  availableQty: number;
};

export type IssuePlannerCartItem = {
  id: string;
  plannerItemId: string;
  name: string;
  lin: string;
  nsn?: string | null;
  assetIds: string[];
  sourceLocationIds?: string[];
  sourceLocationLabel?: string | null;
  ieKitId?: string | null;
  kitName?: string | null;
  selectedCatalogId?: string | null;
  sizeLabel?: string | null;
  expirationDate?: string | null;
};

export type IssuePlannerSizeOption = {
  catalogId: string;
  displayName: string;
  sizeLabel?: string | null;
  entityIdentifier: string | null;
  nsn: string | null;
};

// Special option to explicitly choose the parent (non-sized) when deferring size selection.
export const NON_SIZED_OPTION_ID = '__parent__';

export type IssueAdditionalCartItem = {
  groupId: string;
  name: string;
  source: string;
  assetIds: string[];
  sourceLocationIds?: string[];
  sourceLocationLabel?: string | null;
  lin?: string | null;
  nsn?: string | null;
  sizeLabel?: string | null;
  expirationDate?: string | null;
};

export type IssueBuyProgramCartItem = {
  id: string;
  catalog: IEMBuyProgramCatalogItem;
  quantity: number;
  maxQuantity?: number;
  // Reimbursement pricing fields (entered before adding to cart)
  actualPrice: number; // User-entered price per unit (must be <= catalog.unitPrice ceiling)
  tax: number; // User-entered tax per unit
  shipping: number; // User-entered shipping per unit
  // Per-item receipt date (YYYY-MM-DD), required at add-to-cart time (#458)
  receiptDate?: string;
  ieKitId?: string | null;
};
